
function Skills() {
    return (

        <div className="row">
            <div className="offset-1 col-10">

                <div className="row">
                    <div className="offset-2 col-4 offset-lg-1 col-lg-2 p-2 text-center">
                        <img src={'images/icons/skills_html.png'} className='img-fluid shadow img-fo' alt='html' />
                    </div>
                    <div className="col-4 col-lg-2 p-2 text-center">
                        <img src={'images/icons/skills_css3.png'} className='img-fluid shadow img-fo' alt='css' />
                    </div>
                    <div className="col-4 col-lg-2 p-2 text-center">
                        <img src={'images/icons/skills_bootstrap.png'} className='img-fluid shadow img-fo' alt='bootstrap' />
                    </div>
                    <div className="col-4 col-lg-2 p-2 text-center">
                        <img src={'images/icons/skills_js.png'} className='img-fluid shadow img-fo' alt='javascript' />
                    </div>
                    <div className="col-4 col-lg-2 p-2 text-center">
                        <img src={'images/icons/skills_react.png'} className='img-fluid shadow img-fo' alt='react' />
                    </div>
                </div>

                <div className="row">
                    <div className="offset-2 col-4 offset-lg-1 col-lg-2 p-2 text-center">
                        <img src={'images/icons/skills_python.png'} className='img-fluid shadow img-be' alt='python' />
                    </div>
                    <div className="col-4 col-lg-2 p-2 text-center">
                        <img src={'images/icons/skills_php.png'} className='img-fluid shadow img-be' alt='php' />
                    </div>
                    <div className="col-4 col-lg-2 p-2 text-center">
                        <img src={'images/icons/skills_MySQL.png'} className='img-fluid shadow img-be' alt='mysql' />
                    </div>
                    <div className="col-4 col-lg-2 p-2 text-center">
                        <img src={'images/icons/skills_terraform.png'} className='img-fluid shadow img-be' alt='terraform' />
                    </div>
                    <div className="col-4 col-lg-2 p-2 text-center">
                        <img src={'images/icons/skills_helm.png'} className='img-fluid shadow img-be' alt='helm' />
                    </div>
                </div>

                <div className="row">
                    <div className="offset-2 col-4 offset-lg-1 col-lg-2 p-2 text-center">
                        <img src={'images/icons/skills_git.png'} className='img-fluid shadow img-be' alt='git' />
                    </div>
                    <div className="col-4 col-lg-2 p-2 text-center">
                        <img src={'images/icons/skills_aws.png'} className='img-fluid shadow img-be' alt='php' />
                    </div>
                    <div className="col-4 col-lg-2 p-2 text-center">
                        <img src={'images/icons/skills_jenkins.png'} className='img-fluid shadow img-be' alt='jenkins' />
                    </div>
                    <div className="col-4 col-lg-2 p-2 text-center">
                        <img src={'images/icons/skills_postman.png'} className='img-fluid shadow img-be' alt='postman' />
                    </div>
                    <div className="col-4 col-lg-2 p-2 text-center">
                        <img src={'images/icons/skills_gitlab.png'} className='img-fluid shadow img-be' alt='gitlab' />
                    </div>
                </div>

            </div>
        </div>
    );
}

export default Skills;